import useUpdatePoolTaskSubmissions from '../../../../../hooks/useUpdatePoolTaskSubmissions'
import TaskAllocationAmount from '../../../../../shared_components/Missions/TaskAllocationAmount'
import SharedTwitterTask, {
  Props,
} from '../../../../../shared_components/Missions/Types/Twitter'

export default function TwitterTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdatePoolTaskSubmissions()
  return (
    <SharedTwitterTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} />}
    />
  )
}
